module.exports = __webpack_public_path__ + "static/img/sousuo-bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sousuo-bg.png
// module id = 588
// module chunks = 0